import { Helmet } from 'react-helmet-async';
import { LOGO_URL } from '../utils/seo';

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact opnemen met Timmers BV - Oosterhout</title>
        <meta name="description" content="Heeft u vragen over glas of glasbeslag? Neem contact op met Timmers BV in Oosterhout. Wij helpen u graag met uw vragen over producten en maatwerk." />
        <link rel="canonical" href="https://timmers-bv.nl/contact" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Contact opnemen met Timmers BV - Oosterhout" />
        <meta property="og:description" content="Heeft u vragen over glas of glasbeslag? Neem contact op met Timmers BV in Oosterhout." />
        <meta property="og:image" content={LOGO_URL} />
        <meta property="og:url" content="https://timmers-bv.nl/contact" />
        <meta property="og:locale" content="nl_NL" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Timmers BV",
            "url": "https://timmers-bv.nl",
            "telephone": "+31162461175",
            "email": "info@timmers-bv.nl",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Krombraak 8-10",
              "addressLocality": "Oosterhout",
              "postalCode": "4906 CR",
              "addressCountry": "NL"
            },
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday"],
                "opens": "08:00",
                "closes": "17:00"
              },
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Friday",
                "opens": "08:00",
                "closes": "16:00"
              }
            ]
          })}
        </script>
      </Helmet>
      <main id="maincontent" className="page-main" style={{ marginTop: '30px' }}>
        <div className="row-full-width-inner">
          <h1>Waar kunnen wij u mee helpen?</h1>
          <div>
            <p>
              Heeft u vragen over onze producten of maatwerk oplossingen? Of bent u benieuwd wat
              wij voor uw bedrijf kunnen betekenen? Neem dan gerust contact met ons op:
            </p>
            <p>
              <strong>Timmers B.V.</strong><br />
              Adres: Krombraak 8-10, 4906 CR Oosterhout<br />
              Telefoonnummer: <a href="tel:+31162461175">0031 (0)162 461175</a><br />
              E-mailadres: <a href="mailto:info@timmers-bv.nl">info@timmers-bv.nl</a>
            </p>
            <p>
              Whatsapp: <a href="tel:+31630782297">0031 6 30782297</a>
            </p>
            <p>
              KvK: Breda 20122320<br />
              BTW: NL8152.47.199B01<br />
              IBAN: NL87 RABO 0182 4690 69<br />
              BIC: RABONL2U
            </p>
            <p>
              <strong>Openingstijden:</strong><br />
              Maandag t/m donderdag van 8:00 tot 17:00u<br />
              Vrijdag van 8:00u tot 16:00u
            </p>
          </div>
        </div>

        <section className="basic-section">
          <div className="container">
            <div>
              <div className="title-block center">
                <div className="sub-text">antwoord op je vragen</div>
                <h2 className="h2">Veel gestelde vragen</h2>
                <div className="paragraph">
                  Zit jouw vraag er niet tussen? Neem gerust contact op met onze klantenservice.
                </div>
              </div>

              <div className="faq-3-list">
                <details className="faq-3-accordion w-dropdown">
                  <summary className="faq-3-question w-dropdown-toggle">
                    <div>Wat is de levertijd?</div>
                    <div className="faq-3-icon">
                      <div className="faq-3-arrow w-embed">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16" fill="none">
                          <path d="M8.00045 8.78126L11.3003 5.48145L12.2431 6.42425L8.00045 10.6669L3.75781 6.42425L4.70063 5.48145L8.00045 8.78126Z" fill="currentColor" />
                        </svg>
                      </div>
                    </div>
                  </summary>
                  <div className="faq-3-content">
                    <p className="paragraph">
                      De levertijd voor glas hangt af van de glassoort die u zou willen bestellen.
                      U kunt hiervoor het beste contact opnemen met onze verkoop binnendienst.
                      <br /><br />
                      De meeste losse artikelen zoals glasbeslag en glasartikelen zijn uit voorraad
                      leverbaar. Indien u deze producten los besteld is de levertijd 2-3 werkdagen.
                      Als u losse onderdelen combineert met glas houden we de levertijd van glas aan.
                    </p>
                  </div>
                </details>
                <div className="divider-tertiary"></div>

                <details className="faq-3-accordion w-dropdown">
                  <summary className="faq-3-question w-dropdown-toggle">
                    <div>Waar kan ik mijn bestellingen bekijken?</div>
                    <div className="faq-3-icon">
                      <div className="faq-3-arrow w-embed">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16" fill="none">
                          <path d="M8.00045 8.78126L11.3003 5.48145L12.2431 6.42425L8.00045 10.6669L3.75781 6.42425L4.70063 5.48145L8.00045 8.78126Z" fill="currentColor" />
                        </svg>
                      </div>
                    </div>
                  </summary>
                  <div className="faq-3-content">
                    <p className="paragraph">
                      Voor een overzicht van uw bestellingen kunt u altijd inloggen in uw account.
                      Klik in de linkerkolom op "mijn bestellingen", u krijgt dan een overzicht van
                      alle bestellingen en u kunt vorige bestellingen opnieuw bestellen.
                    </p>
                  </div>
                </details>
                <div className="divider-tertiary"></div>

                <details className="faq-3-accordion w-dropdown">
                  <summary className="faq-3-question w-dropdown-toggle">
                    <div>Hoe kan ik artikelen retourneren?</div>
                    <div className="faq-3-icon">
                      <div className="faq-3-arrow w-embed">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16" fill="none">
                          <path d="M8.00045 8.78126L11.3003 5.48145L12.2431 6.42425L8.00045 10.6669L3.75781 6.42425L4.70063 5.48145L8.00045 8.78126Z" fill="currentColor" />
                        </svg>
                      </div>
                    </div>
                  </summary>
                  <div className="faq-3-content">
                    <p className="paragraph">
                      Via Downloads kunt u een retourformulier vinden. Dit formulier dient volledig
                      ingevuld in het retourpakket worden bijgesloten. Zodra wij de retourzending
                      hebben ontvangen zal deze worden gecontroleerd op beschadigingen. Als het artikel
                      in goede staat is aangeleverd maken wij een creditnota voor u aan. Het creditbedrag
                      kunt u dan verrekenen bij de volgende betaling.
                    </p>
                  </div>
                </details>
                <div className="divider-tertiary"></div>

                <details className="faq-3-accordion w-dropdown">
                  <summary className="faq-3-question w-dropdown-toggle">
                    <div>Hoe kan ik mijn bestelling betalen?</div>
                    <div className="faq-3-icon">
                      <div className="faq-3-arrow w-embed">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16" fill="none">
                          <path d="M8.00045 8.78126L11.3003 5.48145L12.2431 6.42425L8.00045 10.6669L3.75781 6.42425L4.70063 5.48145L8.00045 8.78126Z" fill="currentColor" />
                        </svg>
                      </div>
                    </div>
                  </summary>
                  <div className="faq-3-content">
                    <p className="paragraph">
                      Uw bestelling kan op rekening worden betaald, na het aanmaken van een account.
                      De betaaltermijn is binnen 14 dagen na levering.
                    </p>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Contact;
